import * as React from 'react'

import { ChipGroup } from '~/components/chip/ChipGroup'
import { ToggleGroup } from '~/utilities/radix-overrides/toggle-group'

type TChipToggleGroupRootProps = React.ComponentProps<typeof ChipGroup> &
  React.ComponentProps<typeof ToggleGroup.Root>

export const ChipToggleGroupRoot = React.forwardRef<
  HTMLDivElement,
  TChipToggleGroupRootProps
>((props, ref) => {
  return (
    <ChipGroup
      ref={ref}
      as={ToggleGroup.Root}
      orientation="horizontal"
      {...props}
    />
  )
})
